var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-cards"},_vm._l((_vm.options),function(option){return (option.show)?_c('card',{key:option.name,attrs:{"option":option}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }